export default __webpack_public_path__ + "static/media/buy_01.e4196d50.png";